export const WIX_HEADER_HEIGHT = '54px';
export const WIX_STUDIO_HEADER_HEIGHT = '47px';
export let ExperimentSpecs = /*#__PURE__*/function (ExperimentSpecs) {
  ExperimentSpecs["MatchDomainCycleToPremiumCycle"] = "matchDomainCycleToPremiumCycle";
  ExperimentSpecs["LoggedInConnect"] = "loggedInMobileConnectAndAssignDomains";
  ExperimentSpecs["BmHarmonyTheme"] = "bmHarmonyTheme";
  return ExperimentSpecs;
}({});
//# sourceMappingURL=constants.js.map